import { render, staticRenderFns } from "./TaskViewDescriptionDispatcher.vue?vue&type=template&id=6b27da36&scoped=true&lang=pug&"
import script from "./TaskViewDescriptionDispatcher.vue?vue&type=script&lang=js&"
export * from "./TaskViewDescriptionDispatcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b27da36",
  null
  
)

export default component.exports